import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { IMaterialsSFilter } from 'src/@types/SearchFilterTypes';

import { Page } from '../../../../components/Page';

import MaterialsGrid from './MaterialsGrid';
import SearchForm from './SearchForm';
/** * ## Materials 설명 * */
export const Materials = observer(() => {
  // 검색 조건
  const [searchData, setSearchData] = useState<IMaterialsSFilter>({} as IMaterialsSFilter);

  // 목록 검색
  const onSearch = (data: IMaterialsSFilter) => {
    setSearchData(data);
  };
  return (
    <Page>
      <SearchForm onSearch={onSearch} />
      <MaterialsGrid searchData={searchData} />
    </Page>
  );
});
export default Materials;
